module.exports = __webpack_public_path__ + "img/About-us_banner.0665df69.jpg";